import { Component, OnInit, Inject } from '@angular/core';
import { DialogService } from '../../../shared/services/dialog.service';
import { DialogComponent } from '../../../components/dialog/dialog.component';
import { Utility } from '../../../common/utility';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { AppConstants } from '../../../shared/constants/constants';
import * as moment from 'moment';

@Component({
    selector: 'clinic-schedule',
    templateUrl: 'clinic-schedule-popup.component.html',
    providers: []
})

export class ClinicSchedulePopupComponent implements OnInit {
    public appConstants = AppConstants;
    constructor(public dialogService: DialogService,
        public dialogRef: MdDialogRef<ClinicSchedulePopupComponent>,
        public utility: Utility,
        @Inject(MD_DIALOG_DATA) public data: any
    ) {
    }
    ngOnInit() {
      if (this.data) {
        this.data.forEach(item => {
            item['startTime'] = moment(item['startTime'], 'h:mm').format('hh:mm A');
            item['endTime'] = moment(item['endTime'], 'h:mm').format('hh:mm A');
        });
      }
    }

    onCloseDialog() {
        this.dialogRef.close();
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/booking/manage-booking/clinic-schedule-popup.component.ts